/**
 * 处理动态菜单图标
 */
import React from 'react';
import type { MenuDataItem } from '@ant-design/pro-layout';
import * as allIcons from '@ant-design/icons';
 
// const fixMenuItemIcon = (menus: MenuDataItem[], iconType = 'Outlined'): MenuDataItem[] => {
//    menus.forEach((item) => {
//       const { icon, routes } = item
//       if (typeof icon === 'string' && icon != null) {
//          const fixIconName = icon.slice(0, 1).toLocaleUpperCase() + icon.slice(1) + iconType
//          // eslint-disable-next-line no-param-reassign
//          item.icon = React.createElement(allIcons[fixIconName] || allIcons[icon])
//       }
//       // eslint-disable-next-line no-param-reassign,@typescript-eslint/no-unused-expressions
//       routes && routes.length > 0 ? item.routes = fixMenuItemIcon(routes) : null
//    });
//    return menus
// };
 
// export default fixMenuItemIcon;


/**
 * 处理动态菜单图标并过滤权限
 */
const filterMenuByAccess = (
  menus: MenuDataItem[],
  roles: string[], // 用户的角色
  iconType = 'Outlined'
): MenuDataItem[] => {
  return menus
    .filter((item) => {
      // 如果没有 access 字段，默认显示
      if (!item.access) return true;

      // 确保 access 是数组
      const accessArray = Array.isArray(item?.access) ? item?.access : [item?.access];

      // 检查 roles 和 accessArray 是否有交集
      return accessArray.some((role) => roles?.includes(role));
    })
    ?.map((item) => {
      const { icon, routes } = item;

      // 处理图标
      if (typeof icon === 'string' && icon != null) {
        const fixIconName = icon.slice(0, 1).toLocaleUpperCase() + icon.slice(1) + iconType;
        // eslint-disable-next-line no-param-reassign
        item.icon = React.createElement(allIcons[fixIconName] || allIcons[icon]);
      }

      // 递归处理子菜单
      if (routes && routes.length > 0) {
        item.routes = filterMenuByAccess(routes, roles, iconType);
      }

      return item;
    });
};

export default filterMenuByAccess;